// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tatvam-grid{margin-top:3rem !important}.table-html-icon{height:25px;margin-top:2px;margin-right:2px;float:right;cursor:pointer;object-fit:contain}\n", ""]);
// Exports
module.exports = exports;
